"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var pre_chat_service_1 = require("../../services/pre-chat.service");
var FormHeaderComponent = /** @class */ (function () {
    function FormHeaderComponent(preChatService) {
        this.preChatService = preChatService;
        this.resources = resources;
    }
    Object.defineProperty(FormHeaderComponent.prototype, "isTop", {
        get: function () {
            return window.top === window;
        },
        enumerable: true,
        configurable: true
    });
    FormHeaderComponent.prototype.ngOnInit = function () {
    };
    FormHeaderComponent.prototype.toggleChat = function () {
        this.preChatService.toggleChat();
    };
    return FormHeaderComponent;
}());
exports.FormHeaderComponent = FormHeaderComponent;
